import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { DialogVideoData } from './dialog-video.interface';

@Component({
  selector: 'fantaz-dialog-video',
  templateUrl: './dialog-video.component.html',
  styleUrls: ['./dialog-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogVideoComponent {
  constructor(
    @Inject(DIALOG_DATA) public data: DialogVideoData,
    private readonly dialogRef: DialogRef,
  ) {}

  close() {
    this.dialogRef.close();
  }
}
